export default {"globalMeta":{"charset":"utf-8","viewport":"width=device-width, initial-scale=1"},"mixinKey":"setup"}